import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_375: DocMigration = {
  maxSchemaVersion: "0.0.375",
  description: "Remove unused windowCatalog field",
  apply(json: any) {
    if (json.windowCatalog) {
      delete json.windowCatalog;
    }
    return json;
  },
};

export default migration_0_0_375;
